export enum FORM_NAME {
  CREATE_SURVEY_HEALTH_QUESTION = 'CREATE_SURVEY_HEALTH_QUESTION',
  UPDATE_SURVEY_HEALTH_QUESTION = 'UPDATE_SURVEY_HEALTH_QUESTION',
}
